import type { RenderableQuestion, SingleSelectResponse } from '@assessments/shared'
import { cn } from '@/lib/utils'

interface Props {
  question: RenderableQuestion
  value: SingleSelectResponse
  onChange: (response: SingleSelectResponse) => void
  labelledBy: string
  describedBy?: string
  disabled?: boolean
}

/** Radio list: exactly one option selectable; the selected option is distinguished (FR-002/003/004). */
export function SingleSelectQuestion({
  question,
  value,
  onChange,
  labelledBy,
  describedBy,
  disabled,
}: Props) {
  const name = `q-${question.id}`
  return (
    <div
      role="radiogroup"
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      className="mt-3 space-y-2"
    >
      {question.options.map((option) => {
        const selected = value.selectedOptionId === option.id
        return (
          <label
            key={option.id}
            className={cn(
              'flex cursor-pointer items-center gap-3 rounded-button border px-3 py-2 text-sm',
              selected
                ? 'border-primary bg-primary/5 font-medium text-body'
                : 'border-input text-body',
              disabled && 'cursor-not-allowed opacity-50',
            )}
          >
            <input
              type="radio"
              name={name}
              value={option.id}
              checked={selected}
              disabled={disabled}
              onChange={() => onChange({ kind: 'single', selectedOptionId: option.id })}
              className="h-4 w-4"
            />
            <span>{option.label}</span>
          </label>
        )
      })}
    </div>
  )
}
